<template>
  <select-dict
    v-model="glassThicknesses"
    :selectList="glassThinknessList"
    :select-first-item="true"
    :disabled="true"
  />
</template>

<script setup lang="ts">
import { defineModel, watch, ref, computed } from "vue";
import SelectDict from "@/components/UI/SelectDict.vue";

import { useDictStore } from "@/stores/dictStore";
import { useNewEstimateStore } from "@/stores/new/estimateStore";
import { Dictionary } from "@/models/dictionary";

const estimateStore = useNewEstimateStore();
const dictStore = useDictStore();

const systemCode = computed(() => estimateStore.estimate.installedSystemCode);
const glassThicknesses = defineModel<string>();
const glassThinknessList = ref<Dictionary[]>([]);

watch(
  () => glassThicknesses.value,
  (defaultGlassThick) => {
    if (!defaultGlassThick) {
      glassThinknessList.value = [];
      return;
    }
    const glassThickInfo = dictStore.findGlassThickness(
      defaultGlassThick,
      systemCode.value,
    );
    glassThinknessList.value = [glassThickInfo];
  },
  {
    immediate: true,
    deep: true,
  },
);
</script>

<style lang="scss" scoped></style>
